import React from 'react';
import useLanguage from '../hooks/useLanguage';

/**
 * Tick the guest supplies a unit needs.
 *
 * The list is the crew's own supplies sheet — the active cleaning template, sent by the server — so
 * ops and the cleaner are naming the same things, and nothing invented in a browser can reach a
 * refill task (the server resolves every id against that template).
 *
 * Presentational on purpose: items in, chosen ids out, no state of its own. `CreateTaskModal` uses
 * it today; the complaint repair form uses it next (tasks/complaint-repair-task-types.md).
 */
const SuppliesPicker = ({ items = [], selected = [], onChange, disabled = false, label }) => {
  const { isArabic } = useLanguage();

  const toggle = (itemId) => {
    if (disabled) return;
    onChange(selected.includes(itemId)
      ? selected.filter(id => id !== itemId)
      : [...selected, itemId]);
  };

  if (items.length === 0) return null;

  return (
    <div className="d-flex flex-wrap gap-2" role="group" aria-label={label}>
      {items.map(item => {
        const active = selected.includes(item.itemId);
        return (
          <button
            key={item.itemId}
            type="button"
            className="touch-btn touch-btn-sm"
            onClick={() => toggle(item.itemId)}
            disabled={disabled}
            aria-pressed={active}
            style={{
              border: '2px solid #471396',
              borderRadius: '22px',
              background: active ? '#471396' : 'transparent',
              color: active ? '#fff' : '#471396',
              fontWeight: 600,
              opacity: disabled ? 0.6 : 1
            }}
          >
            {isArabic ? item.labelAr : (item.labelEn || item.labelAr)}
          </button>
        );
      })}
    </div>
  );
};

export default SuppliesPicker;
